<!--考题统计-->
<template>
    <div class="page">
       <el-form class="page-query" :inline="true" size="mini">
            <select-multi-orgs @orgsChange="orgsChange"></select-multi-orgs>
            <select-multiple :nameArrays="selectNames"
                             @getForLevelVal="getForLevelVal"
                             @getDifficultyVal="getDifficultyVal"
                             @getTopicTypeVal="getTopicTypeVal">
            </select-multiple>
            <select-multi-knowledge @knowledgeChange="knowledgeChange"></select-multi-knowledge>
            <el-form-item style="display: block;">
                <el-button type="primary" @click="query" round>{{$t('c.query')}}</el-button>
            </el-form-item>
        </el-form>
        <el-row :gutter="20">
            <el-col :span="col">
                <ui-card :title="$t('count.topicType')" icon="nucfont inuc-pie-chart" class="ibox">
                    <div v-show="questionTypePieShow" id="questionTypePie" class="knowledgeBox"></div>
                    <p v-show="!questionTypePieShow" class="emptyBox"><i
                        class="nucfont inuc-empty-file"></i>{{$t('c.noData')}}</p>
                </ui-card>
            </el-col>
            <el-col :span="col">
                <ui-card :title="$t('c.knowledgePoint')" icon="nucfont inuc-pie-chart" class="ibox">
                    <div v-show="knowledgePieShow" id="questionKnowledgePie" class="knowledgeBox"></div>
                    <p v-show="!knowledgePieShow" class="emptyBox"><i
                        class="nucfont inuc-empty-file"></i>{{$t('c.noData')}}</p>
                </ui-card>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col>
                <ui-card :title="$t('c.difficulty')" icon="nucfont inuc-line-chart" class="ibox">
                    <div v-show="difficultLevelShow" id="difficultLevel" class="content_detail-middle">
                        <div class="left">
                            <el-progress type="circle" :percentage="difficultRate" color="#f18d82" :stroke-width="10"
                                         :width="180"></el-progress>
                            <p>{{difficult.name}}</p>
                        </div>
                        <div class="center">
                            <el-progress type="circle" :percentage="mediumRate" color="#59a4cb" :stroke-width="10"
                                         :width="180"></el-progress>
                            <p>{{medium.name}}</p>
                        </div>
                        <div class="right">
                            <el-progress type="circle" :percentage="easyRate" color="#f2d989" :stroke-width="10"
                                         :width="180"></el-progress>
                            <p>{{easy.name}}</p>
                        </div>
                    </div>
                    <p v-show="!difficultLevelShow" class="content_detail-middle emptyBox">
                        <i class="nucfont inuc-empty-file"></i>
                        {{$t('c.noData')}}</p>
                </ui-card>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <statistics-upload-top ref="uploadOrder"
                                   :statisticName="$t('count.uploadRank')"
                                   id="uploadOrder"
                                   :sourceType="courseType"
                                   :legendName="$t('count.uploadNum')">
            </statistics-upload-top>
        </el-row>
        <el-row :gutter="20">
            <el-col>
                <ui-card :title="$t('count.topicDetail')" icon="nucfont inuc-list-chart" class="ibox">
                    <el-form :inline="true" size="mini" style="padding: 10px">
                        <el-form-item :label="$t('count.topicNo')">
                            <el-input v-model="filters[0].value" @input="currentPage=1" :placeholder="$t('count.topicNo')" clearable></el-input>
                        </el-form-item>
                        <!--<el-form-item>-->
                            <!--<el-button type="primary" @click="topicQuery" round>{{$t('c.query')}}</el-button>-->
                        <!--</el-form-item>-->
                    </el-form>
                    <data-tables class="form-table"
                                 ref="courseTable"
                                 :data="tableData"
                                 :table-props="tableProps"
                                 :current-page.sync="currentPage"
                                 :page-size="20"
                                 :filters="filters"
                                 :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                    >
                        <el-table-column :label="$t('count.topicNo')" align="center" property="number" show-overflow-tooltip sortable>
                            <template slot-scope="scope">
                                <span>{{scope.row.number}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('count.topicType')" align="center" property="topicTypeName" sortable>
                            <template slot-scope="scope">
                                <span class="tg-bg" :class="topicTypeBg(scope.row.topicType)">{{scope.row.topicTypeName}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-for="(title,index) in titles" :prop="title.prop" :label="title.label"
                                         :key="index"
                                         :width="title.width"
                                         align="center"
                                         show-overflow-tooltip
                                         sortable="custom">
                        </el-table-column>
                        <el-table-column :label="$t('topic.rightRate')" align="center" property="accuracy" sortable>
                            <template slot-scope="scope">
                                <span>{{scope.row.accuracy!=null ?(Math.round(scope.row.accuracy * 10000) / 100 + '%'):'--'}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('c.creator')" align="center" property="name" sortable>
                            <template slot-scope="scope">
                                <span>{{scope.row.name}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('c.operation')" align="center">
                            <div class="btn-cell" slot-scope="scope">
                                <i class="nucfont inuc-preview"
                                   :title="$t('c.view')"
                                   @click="viewTopic(scope.row.topicID,scope.row.topicType)"></i>
                                <i class="nucfont inuc-edit"
                                   v-if="userInfo.userID==scope.row.userID"
                                   :title="$t('c.edit')"
                                   @click="$router.push({name: 'statisticsTopicEdit', params:{id: scope.row.topicID, type: scope.row.topicType}})"></i>
                            </div>
                        </el-table-column>
                    </data-tables>
                </ui-card>
            </el-col>
        </el-row>
        <stats-topic-view :topicInfoVisible="topicInfoVisible" ref="topicView" :topicInfo="topicInfo">
        </stats-topic-view>
        <transition enter-active-class="animated zoomInRight"
                    leave-active-class="animated zoomOutUp">
            <router-view @updateData="query"></router-view>
        </transition>
    </div>
</template>

<script>
    import api from '@/api';
    import {Ticket} from '@/utils';
    import {mapGetters} from 'vuex';
    import SelectMultiOrgs from '@/components/SelectMultiOrgs';
    import SelectMultiple from '@/components/Selectmultiple';
    import SelectMultiKnowledge from '@/components/SelectMultiKnowledge';
    import StatisticsUploadTop from "@/components/Statistics/StatisticsUploadTop";
    import StatsTopicView from "@/components/Statistics/StatsTopicView";
    import uiCard from '@/components/Statistics/StatisticUICard';

    var echarts = require('echarts');
    export default {
        components: {
            SelectMultiOrgs,
            SelectMultiple,
            SelectMultiKnowledge,
            StatisticsUploadTop,
            StatsTopicView,
            uiCard
        },

        data() {
            return {
                filters: [{prop: 'number',value: ''}],
                userInfo: {},
                formSearch: {
                    orgIds: [],
                    types: [],
                    forLevels: [],
                    difficulties: [],
                    knowledges: [0],
                    number: undefined
                },
                topicSearch: {
                    number: undefined
                },
                selectNames: [
                    {
                        key: "topicType",
                    }, {
                        key: "forLevel",
                    }, {
                        key: "difficulty",
                    }],
                knowledgePieShow: false,
                questionTypePieShow: false,
                difficultLevelShow: false,
                uploadOrderShow: false,
                courseType: undefined,
                //  难易程度
                difficult: [],
                medium: [],
                easy: [],
                difficultRate: 0,
                mediumRate: 0,
                easyRate: 0,
                //  考题详情
                tableData: [],
                tableProps: {
                    border: true,
                    stripe: true,
                    rowKey: row => row.id,
                    height: "auto"
                },
                titles: [
                    {
                        prop: 'knowledgeName',
                        label: this.$t('c.knowledgePoint')
                    }, {
                        prop: 'usageCount',
                        label: this.$t('count.frequency')
                    }
                ],
                currentPage: 1,
                topicInfoVisible: false,
                topicInfo: {}
            }
        },
        created() {
            if (Ticket.get()) {
                this.userInfo = Ticket.get();
            }
        },
        mounted() {

            this.$nextTick(() => {
                this.query();
            })
        },
        computed: {
            ...mapGetters([
                'orgTree',
                'knowledgeList'
            ]),
            col() {
                let windowWidth = $(document).width();
                let col = 12;

                if (windowWidth <= 1400) {
                    col = 24;
                }

                return col;
            }
        },
        methods: {
            query() {//查询
                let queryData = {...this.formSearch};

                // 全选不传值
                let searchArr = ['types', 'forLevels', 'difficulties', 'knowledges'];
                searchArr.forEach(ele => {
                    if (this.formSearch[ele].includes(0)) {
                        delete queryData[ele];
                    }
                });

                this.questionType(queryData);
                this.getKnowledgeTips(queryData);
                this.difficultyLevel(queryData);
                this.upLoadCount(queryData);
                this.examQuestion(queryData);
            },
            // 查询条件开始
            orgsChange(data) {
                this.formSearch.orgIds = data;
            },
            getForLevelVal(data) {
                this.formSearch.forLevels = data;
            },
            getDifficultyVal(data) {
                this.formSearch.difficulties = data;
            },
            getTopicTypeVal(data) {
                this.formSearch.types = data;
            },
            knowledgeChange(data) {
                this.formSearch.knowledges = data;
            },
            //查询条件结束

            questionType(queryData) {
                let _this = this;
                let typeChart = echarts.init(document.getElementById("questionTypePie"));
                //制定图标的配置项和数据
                typeChart.showLoading();
                api.getTopicStatisticsByType(queryData).then((res) => {
                    if (res.package.innerRing) {
                        this.questionTypePieShow = true;
                        const outerData = res.package.outerRing;
                        let innerData = res.package.innerRing;
                        innerData.forEach((ele, index) => {
                            ele.id = index
                        });
                        outerData.forEach((ele, index) => {
                            ele.id = index
                        });
                        let legendData = [];
                        [...innerData, ...outerData].forEach(value => {
                            legendData.push(value.name);
                        });
                        let option = {
                            color: ['#59a4cb', '#f18d82', '#f2d989', '#37b7c5', '#998b7e', '#ab85e8', '#6a7882', '#c1837f', '#d2a470', '#43a7de', '#ac628d', '#a89a69', '#496c99', '#c478b7', '#7c6d77'],
                            tooltip: {
                                trigger: 'item',
                                formatter: "{a} <br/>{b}: {c} ({d}%)"
                            },
                            legend: {
                                type: 'scroll',
                                icon: 'rect',
                                orient: 'vertical',
                                itemWidth: 25,
                                itemHeight: 4,
                                right: 0,
                                data: legendData,
                                pageButtonGap:15,
                                pageButtonItemGap:15,
                                pageIconSize:[10,10],
//                                formatter: function (name) {
//                                    return name.length > 3 ? name.substr(0, 3) + "..." : name;
//                                }
                            },
                            series: [
                                {
                                    name: this.$t('count.quantity'),
                                    type: 'pie',
//                                    center: ['30%', '45%'],
                                    selectedMode: 'single',
                                    radius: [0, '45%'],

                                    label: {
                                        normal: {
                                            position: 'inner'
                                        },
                                    },
                                    labelLine: {
                                        normal: {
                                            show: false
                                        }
                                    },
                                    data: innerData
                                },
                                {
                                    name: this.$t('count.quantity'),
                                    type: 'pie',
//                                    center: ['30%', '45%'],
                                    radius: ['55%', '75%'],
                                    selectedMode: 'single',
                                    label: {
                                        normal: {
                                            position: 'outer',
                                        }
                                    },
                                    data: outerData
                                }
                            ]
                        };
                        typeChart.hideLoading();
                        typeChart.setOption(option);
                    } else {
                        typeChart.hideLoading();
                        this.questionTypePieShow = false;
                    }

                })
            },
            getKnowledgeTips(queryData) {
                let knowledgeChart = echarts.init(document.getElementById("questionKnowledgePie"));
                //制定图标的配置项和数据
                knowledgeChart.showLoading();
                api.getTopicStatisticsByKnowLedge(queryData).then((res) => {
                    if (res.package.length > 0) {
                        let knowledgeData = res.package;
                        knowledgeData.forEach(item => {
                            if (!item.value) {
                                item.label = {
                                    show: false
                                };
                                item.labelLine = {
                                    show: false
                                }
                            }
                        });
                        let legendData = [];
                        [...knowledgeData].forEach(value => {
                            legendData.push(value.name);
                        });

                        //制定图标的配置项和数据
                        let option = {
                            color: ['#59a4cb', '#f18d82', '#f2d989', '#37b7c5', '#998b7e', '#ab85e8', '#6a7882', '#c1837f', '#d2a470', '#43a7de', '#ac628d', '#a89a69', '#496c99', '#c478b7', '#7c6d77'],
                            tooltip: {
                                trigger: 'item',
                                formatter: '{a}<br/>{b}:{c}({d}%)'
                            },
                            legend: {
                                type: 'scroll',
                                icon: 'rect',
                                orient: 'vertical',
                                itemWidth: 20,
                                itemHeight: 4,
                                right: 0,
                                data: legendData,
                                pageButtonGap:15,
                                pageButtonItemGap:15,
                                pageIconSize:[10,10],
//                                formatter: function (name) {
//                                    return name.length > 3 ? name.substr(0, 3) + "..." : name;
//                                }
                            },
                            series: [
                                {
                                    name: this.$t('c.knowledgePoint'),
                                    type: 'pie',
                                    center: ['34%', '51%'],
                                    radius: '70%',
                                    data: knowledgeData,
                                    label: {
                                        formatter: function (event) {
                                            return event.name.length > 6 ? event.name.substr(0, 6) + "..." : event.name;
                                        },
                                    }
                                }
                            ],
                        };
                        knowledgeChart.setOption(option);
                        this.knowledgePieShow = true;
                        knowledgeChart.hideLoading();
                    } else {
                        this.knowledgePieShow = false;
                        knowledgeChart.hideLoading();
                    }
                })
            },
            difficultyLevel(queryData) {
                api.getTopicStatisticsByDifficulty(queryData).then((res) => {
                    if (res.package != []) {
                        this.difficultLevelShow = true;

                        this.easy = res.package[0];
                        this.medium = res.package[1];
                        this.difficult = res.package[2];

                        let total = res.package[0].value + res.package[1].value + res.package[2].value;
                        this.difficultRate = (total == 0 || !res.package[2].value) ? (0.00) : (Math.round(res.package[2].value / total * 10000) / 100);
                        this.mediumRate = (total == 0 || !res.package[1].value) ? (0.00) : (Math.round(res.package[1].value / total * 10000) / 100);
                        this.easyRate = (total == 0 || !res.package[0].value) ? (0.00) : (Math.round(res.package[0].value / total * 10000) / 100);
                    } else {
                        this.difficultLevelShow = false;
                    }
                })
            },
            upLoadCount(queryData) {
                api.getTopicStatisticsUpLoadCount(queryData).then((res) => {
                    if (res.package) {
                        this.uploadFunction(res.package, 'uploadOrder')
                    } else {
                        this.uploadFunction([], 'uploadOrder')
                    }
                })
            },
            examQuestion(queryData) {
                api.getTopicStatisticsGetTopicListAsync(queryData).then((res) => {
                    if (res.package) {
                        this.tableData = res.package;
                    }
                });
            },
//            topicQuery() {
//                this.examQuestion(this.topicSearch)
//            },
            uploadFunction(data, id) {
                // 父组件多次同一个子组件，调用子组件函数时应加上唯一的标识（id）
                this.$refs[id] && this.$refs[id].upLoadSeption(data, id);
            },
            viewTopicVisible(data) {
                // 父组件多次同一个子组件，调用子组件函数时应加上唯一的标识（id）
                this.$refs['topicView'].topicVisible(data);
            },
            viewTopic(topicID,type) {
                let topicUrl;
                switch (type){
                    case 5:
                        topicUrl=api.getDrTopicInPaper(topicID);
                        break;
                    case 6:
                        topicUrl=api.getCtTopic(topicID);
                        break;
                    default:
                        topicUrl= api.getTheoryTopicDetail(topicID);
                        break;

                }
                topicUrl.then(res => {
                    if (res.package) {
                        this.topicInfo = res.package;
                        this.topicInfoVisible = true;
                        this.viewTopicVisible(res.package)
                    }
                })
            },

            topicTypeBg(type) {
                let bgColor = 'blue';
                switch (type){
                    case 1:
                        bgColor = 'yellow';
                        break;
                    case 2:
                        bgColor = 'blue';
                        break;
                    case 3:
                        bgColor = 'gray';
                        break;
                    case 6:
                        bgColor = 'red';
                        break;
                    case 5:
                        bgColor = 'green';
                        break;
                    default:
                        bgColor = 'other'
                }
                return bgColor
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../style/const.scss';

    .page {
        & /deep/ .el-card {
            border: none;
        }
        & /deep/ .el-card.is-always-shadow {
            box-shadow: none;
        }
        & /deep/ .el-dialog__header {
            border-bottom: 1px dashed #ccc;
        }
        & /deep/ .card-body {
            padding: 20px 0;
        }
    }

    .ibox {
        .content_detail-middle {
            padding: 30px;
            min-height: 300px;
        }
        .emptyBox {
            text-align: center;
            font-size: 18px;
            height: 350px;
            line-height: 350px;
        }
        .knowledgeBox {
            width: 650px;
            height: 350px;
            /*padding: 20px 0;*/
            margin: auto;
        }

        #difficultLevel {
            display: flex;
            .left,
            .right,
            .center {
                flex: 1;
                text-align: center;
                p {
                    font-size: 16px;
                    margin-top: 10px;
                }
            }
        }
        .form-table {
            height: 400px;
        }
        .tg-bg {
            color: #fff;
            display: inline-block;
            min-width: 84px;
            text-align: center;
            &.blue {
                background-color: #2e7faa;
            }
            &.green {
                background-color: #0396a6;
            }
            &.gray {
                background-color: #8c7a6c;
            }
            &.yellow {
                background-color: #ffb822;
            }
            &.red {
                background-color: #f4516c;
            }
            &.other {
                background-color: #5c765b;
            }
        }

    }

    @media screen and (max-width: 1367px) {
        .ui-card /deep/.card-body {
            padding: 10px;
        }
    }
</style>

